import { Divider } from '@mui/material';
import React from 'react';

const ToolbarDivider: React.FC = () => {
	return <Divider orientation="vertical" flexItem />;
};

export default ToolbarDivider;
